import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export var dreamupGenerationSucceeded = createAction("".concat(actionKey, ".GENERATION_SUCCEEDED"), function (generationId, deviationIds) { return ({
    generationId: generationId,
    deviationIds: deviationIds,
}); });
export var dreamupGenerationFailed = createAction("".concat(actionKey, ".GENERATION_FAILED"), function (generationId) { return ({ generationId: generationId }); });
//# sourceMappingURL=actions.js.map